import { z } from 'zod';

export const AllocateCreditResponseDataSchema = z.object({
  notification: z.number().int(),
  subscription: z.number().int(),
});
export const CreditHistoryItemSchema = z.object({
  id: z.string(),
  amount: z.number().int(),
  type: z.string(),
  botId: z.string().optional(),
  billingPlanId: z.string().optional(),
  orderId: z.string().optional(),
  createdAt: z.string(),
});
export const CreditHistoryDataSchema = z.object({
  hasMore: z.boolean(),
  nextCursor: z.string().optional(),
  data: z.array(CreditHistoryItemSchema),
  totals: z.object({
    creditsIn: z.number(),
    creditsOut: z.number(),
    net: z.number(),
  }),
  window: z.object({ from: z.string().optional(), to: z.string() }),
});

export type AllocateCreditResponseData = z.infer<typeof AllocateCreditResponseDataSchema>;
export type CreditHistoryItem = z.infer<typeof CreditHistoryItemSchema>;
export type CreditHistoryData = z.infer<typeof CreditHistoryDataSchema>;
